export default __webpack_public_path__ + "static/media/survey-dark-theme.f1e032b5.png";